import React, {useEffect, useState} from "react";
import "../App.css";

import Axios from "axios";
import { useNavigate } from "react-router-dom";

import { MDBInput, MDBSwitch, MDBTextArea, MDBBtn } from "mdb-react-ui-kit";

import DatePicker, { registerLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import de from "date-fns/locale/de";
import Moment from 'moment';
import {backendPathCustomers, backendPathOfficeEmployees, backendPathPartners, tariffs} from "../Constants";
import Select from "react-select";
import TopNavbar from "../components/Navbar";
import {loadPermissions} from "../functions/permissions";


registerLocale("de", de);
Moment.locale('de');


function NewCustomer() {
    const navigate = useNavigate();

    const [partners, setPartners] = useState([]);
    const [officeEmployees, setOfficeEmployees] = useState([]);

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [phoneNumber, setPhoneNumber] = useState(0);
    const [street, setStreet] = useState("");
    const [houseNumber, setHouseNumber] = useState("");
    const [zip, setZIP] = useState(0);
    const [city, setCity] = useState("");
    const [birthday, setBirthday] = useState();
    const [insurance, setInsurance] = useState("");
    const [degreeOfCare, setDegreeOfCare] = useState(0);
    const [secondPerson, setSecondPerson] = useState(0);
    const [name2, setName2] = useState("");
    const [surname2, setSurname2] = useState("");
    const [phoneNumber2, setPhoneNumber2] = useState(0);
    const [street2, setStreet2] = useState("");
    const [houseNumber2, setHouseNumber2] = useState("");
    const [zip2, setZIP2] = useState(0);
    const [city2, setCity2] = useState("");
    const [birthday2, setBirthday2] = useState();
    const [insurance2, setInsurance2] = useState("");
    const [degreeOfCare2, setDegreeOfCare2] = useState(0);
    const [thirdPerson, setThirdPerson] = useState(0);
    const [name3, setName3] = useState("");
    const [surname3, setSurname3] = useState("");
    const [phoneNumber3, setPhoneNumber3] = useState(0);
    const [relation3, setRelation3] = useState("");
    const [escalation, setEscalation] = useState("");
    const [annotation, setAnnotation] = useState("");
    const [tariff, setTariff] = useState(0);
    const [partnerID, setPartnerID] = useState(-1);
    const [partnerLabel, setPartnerLabel] = useState("");
    const [officeEmployeeID, setOfficeEmployeeID] = useState(-1);
    const [officeEmployeeLabel, setOfficeEmployeeLabel] = useState("");

    const [submitted, setSubmitted] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getPartners = () => {
        Axios.get(backendPathPartners+"partners.php").then((response) => {
            setPartners(response.data.map((val, key) => {
                console.log(response.data);
                return {label: val.Name, value: val.PartnerID };
            }));
        });
    };

    const getOfficeEmployees = () => {
        Axios.get(backendPathOfficeEmployees+"office-employees.php").then((response) => {
            setOfficeEmployees(response.data.map((val, key) => {
                console.log(response.data);
                return {label: val.FirstName + " " + val.LastName, value: val.OfficeEmployeeID };
            }));
        });
    };

    const handleChangeRaw = (date) => {
        console.log("raww");
        const newRaw = new Date(date.currentTarget.value);
        if (newRaw instanceof Date && !isNaN(newRaw)) {
          setBirthday(newRaw);
        }
    };

    const checkCompleteness = () => {
        if (!name || !surname || !phoneNumber || !street || !houseNumber || !zip || !city || !birthday || !insurance || !degreeOfCare) {
            return false;
        }
        return zip.toString().length === 5;
    };

    const addCustomer = () => {
        setSubmitted(true);

        if (!checkCompleteness()) {
            console.log("not complete");
            return;
        }
        console.log("complete");

        Axios.get(`${backendPathCustomers}create-customer.php`, {
            params: {
                name: name,
                surname: surname,
                phoneNumber: phoneNumber,
                street: street,
                houseNumber: houseNumber,
                zip: zip,
                city: city,
                birthday: Moment(birthday).format("YYYY-MM-DD"),
                insurance: insurance,
                degreeOfCare: degreeOfCare,
                secondPerson: secondPerson,
                name2: name2,
                surname2: surname2,
                phoneNumber2: phoneNumber2,
                street2: street2,
                houseNumber2: houseNumber2,
                zip2: zip2,
                city2: city2,
                birthday2: Moment(birthday2).format("YYYY-MM-DD"),
                insurance2: insurance2,
                degreeOfCare2: degreeOfCare2,
                thirdPerson: thirdPerson,
                name3: name3,
                surname3: surname3,
                phoneNumber3: phoneNumber3,
                relation3: relation3,
                escalation: escalation,
                annotation: annotation,
                tariff: tariff,
                partnerId: partnerID,
                officeEmployeeId: officeEmployeeID,
            }
            
        }).then((response) => {
            console.log(response);
            console.log(name, surname, street, houseNumber, zip, city, birthday, insurance, degreeOfCare, secondPerson);
            navigate('/customers');
        });
    };


    useEffect(() => {
        getPartners();
        getOfficeEmployees();
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    return (
        <div>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>

            <div className="main">
                <div className="header">
                    <h2>Neuen Kunden anlegen</h2>
                </div>

                <div className='input-form'>
                    <MDBInput className="input" label='Vorname' id='form1' type='text' onChange={(event) => {
                        setName(event.target.value);
                    }}/>
                    {(submitted && !name) ?
                        <p className="validation-label">Vorname darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input" label='Nachname' id='form2' type='text' onChange={(event) => {
                        setSurname(event.target.value);
                    }}/>
                    {(submitted && !surname) ?
                        <p className="validation-label">Nachname darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Telefon' type='number' onChange={(event) => {
                        setPhoneNumber(event.target.value);
                    }}/>
                    {(submitted && !phoneNumber) ?
                        <p className="validation-label">Telefonnummer darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Straße' id='form2' type='text' onChange={(event) => {
                        setStreet(event.target.value);
                    }}/>
                    {(submitted && !street) ?
                        <p className="validation-label">Straße darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Hausnummer' id='form2' type='text'
                              onChange={(event) => {
                                  setHouseNumber(event.target.value);
                              }}/>
                    {(submitted && !houseNumber) ?
                        <p className="validation-label">Hausnummer darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Postleitzahl' id='form2' type='number'
                              onChange={(event) => {
                                  setZIP(event.target.value);
                              }}/>
                    {(submitted && !zip) ?
                        <p className="validation-label">Postleitzahl darf nicht leer sein oder Text
                            enthalten.</p> : null
                    }
                    {(submitted && zip && zip.toString().length !== 5) ?
                        <p className="validation-label">Postleitzahl ist nicht gültig.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Stadt' id='form2' type='text' onChange={(event) => {
                        setCity(event.target.value);
                    }}/>
                    {(submitted && !city) ?
                        <p className="validation-label">Stadt darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Geburtsdatum</p>
                    <DatePicker className="date-input-1" locale="de" dateFormat='dd.MM.yyyy' selected={birthday}
                                onChange={date => setBirthday(date)}
                    />
                    {(submitted && !birthday) ?
                        <p className="validation-label-date">Geburtsdatum darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Partner</p>
                    <Select className="input" id="select1" placeholder={'Auswählen...'} options={partners}
                            value={partnerID > 0 ? {label: partnerLabel, value: partnerID} : null}
                            onChange={(event) => {
                                console.log(event);
                                setPartnerID(event.value);
                                setPartnerLabel(event.label);
                            }}
                    />

                    <p className="input-label">Paket</p>
                    <Select className="input" id="select2" placeholder={'Auswählen...'} options={tariffs}
                            value={tariff >= 0 ? tariffs[tariff] : ""} onChange={(event) => {
                        setTariff(event.value);
                    }}/>

                    <p className="input-label">Zuständiger Mitarbeiter</p>
                    <Select className="input" id="select3" placeholder={'Auswählen...'} options={officeEmployees}
                            value={officeEmployeeID > 0 ? {label: officeEmployeeLabel, value: officeEmployeeID} : null}
                            onChange={(event) => {
                                console.log(event);
                                setOfficeEmployeeID(event.value);
                                setOfficeEmployeeLabel(event.label);
                            }}/>

                    <MDBInput className="input col-md-6" label='Pflegekasse' id='form2' type='text'
                              onChange={(event) => {
                                  setInsurance(event.target.value);
                              }}/>
                    {(submitted && !insurance) ?
                        <p className="validation-label">Pflegekasse darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Pflegegrad' id='form2' type='number'
                              onChange={(event) => {
                                  setDegreeOfCare(event.target.value);
                              }}/>
                    {(submitted && !degreeOfCare) ?
                        <p className="validation-label">Pflegegrad darf nicht leer sein und darf nur aus Zahlen
                            bestehen.</p> : null
                    }

                    <div className="input">
                        <MDBSwitch id='licenseSwitch' label='zweite Person zu betreuen'
                                   onChange={(event) => setSecondPerson(s => (s + 1) % 2)}/>
                    </div>

                    {secondPerson ?
                        <div className="sub-input">
                            <MDBInput className="input" label='Vorname' color="primary" id='form1' type='text'
                                      onChange={(event) => {
                                          setName2(event.target.value);
                                      }}/>
                            <MDBInput className="input" label='Nachname' id='form2' type='text' onChange={(event) => {
                                setSurname2(event.target.value);
                            }}/>
                            <MDBInput className="input col-md-6" label='Telefon' type='number' onChange={(event) => {
                                setPhoneNumber2(event.target.value);
                            }}/>
                            <MDBInput className="input col-md-6" label='Straße' id='form2' type='text'
                                      onChange={(event) => {
                                          setStreet2(event.target.value);
                                      }}/>
                            <MDBInput className="input col-md-6" label='Hausnummer' id='form2' type='text'
                                      onChange={(event) => {
                                          setHouseNumber2(event.target.value);
                                      }}/>
                            <MDBInput className="input col-md-6" label='Postleitzahl' id='form2' type='number'
                                      onChange={(event) => {
                                          setZIP2(event.target.value);
                                      }}/>
                            <MDBInput className="input col-md-6" label='Stadt' id='form2' type='text'
                                      onChange={(event) => {
                                          setCity2(event.target.value);
                                      }}/>
                            <p className="input-label">Geburtsdatum</p>
                            <DatePicker className="date-input" locale="de" dateFormat='dd.MM.yyyy' selected={birthday2}
                                        onChangeRaw={(e) => handleChangeRaw(e)}
                                        onChange={date => setBirthday2(date)}
                            />
                            <MDBInput className="input col-md-6" label='Pflegekasse' id='form2' type='text'
                                      onChange={(event) => {
                                          setInsurance2(event.target.value);
                                      }}/>
                            <MDBInput className="input col-md-6" label='Pflegegrad' id='form2' type='number'
                                      onChange={(event) => {
                                          setDegreeOfCare2(event.target.value);
                                      }}/>
                        </div>
                        : null}

                    <div className="input"><MDBSwitch id='licenseSwitch' label='zweite Person im Haushalt'
                                                      onChange={(event) => setThirdPerson(s => (s + 1) % 2)}/></div>

                    {thirdPerson ?
                        <div id="third-person">
                            <div className="sub-input">
                                <MDBInput className="input" label='Vorname' color="primary" id='form1' type='text'
                                          onChange={(event) => {
                                              setName3(event.target.value);
                                          }}/>
                                <MDBInput className="input" label='Nachname' id='form2' type='text'
                                          onChange={(event) => {
                                              setSurname3(event.target.value);
                                          }}/>
                                <MDBInput className="input col-md-6" label='Telefon' type='number'
                                          onChange={(event) => {
                                              setPhoneNumber3(event.target.value);
                                          }}/>
                                <MDBInput className="input" label='Beziehung' id='form2' type='text'
                                          onChange={(event) => {
                                              setRelation3(event.target.value);
                                          }}/>
                            </div>
                        </div>
                        : null}

                    <MDBTextArea className="input" label='Eskalationen' id='textAreaExample' rows={4}
                                 onChange={(event) => {
                                     setEscalation(event.target.value);
                                 }}/>
                    <MDBTextArea className="input" label='Notizen' id='textAreaExample' rows={4} onChange={(event) => {
                        setAnnotation(event.target.value);
                    }}/>
                </div>

                <div className="footer">
                    <MDBBtn className="btn" onClick={addCustomer}>Speichern</MDBBtn>
                </div>

            </div>
        </div>
    );
}

export default NewCustomer;